import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/home-banner',
            name: 'admin-home-banner',
            component: () => import(/* webpackChunkName: "page-admin-ad-management-home-banner" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "首页轮播图"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "广告管理"
                                        },
                                        {
                                                  name: "首页轮播图"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
